import React from 'react';
import { useAuth } from '../contexts/AuthContext.jsx';

const ProtectedRoute = ({ children, fallback = null }) => {
  const { isAuthenticated, isLoading, isInitialized } = useAuth();

  // Show loading state while auth is initializing
  if (!isInitialized || isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Ładowanie...</span>
        </div>
      </div>
    );
  }

  // If not authenticated, show fallback or redirect to login
  if (!isAuthenticated) {
    if (fallback) {
      return fallback;
    }
    
    // Default fallback: show login prompt
    return (
      <div className="d-flex justify-content-center align-items-center flex-column" style={{ minHeight: '300px' }}>
        <div className="text-center">
          <i className="bi bi-shield-lock fs-1 text-warning mb-3"></i>
          <h3 className="mb-4">Wymagana autoryzacja</h3>
          <p className="mb-4">Zaloguj się, aby uzyskać dostęp do tej strony.</p>
          <button 
            className="btn btn-primary"
            onClick={() => window.openLoginModal()}
          >
            Log In
          </button>
        </div>
      </div>
    );
  }

  // If authenticated, render the children
  return children;
};

export default ProtectedRoute;
